<div class="fixed inset-0 z-40 bg-[#3D3333CC]" (click)="close()"></div>

<div
  class="fixed top-0 z-50 right-0 bg-white rounded-tl-xl min-h-fit w-full max-w-[360px]"
  style="z-index: 100"
>
  <div class="relative p-4 tablet:p-5">
    <div class="absolute inset-x-0 bottom-0 h-px bg-borderColor"></div>
    <div class="flex justify-between items-center">
      <div class="flex">
        @if (userInitials() && !isB2B()) {
          <div
            class="h-11 w-11 rounded-full bg-white overflow-hidden mr-2.5 flex items-center justify-center text-lg font-semibold border border-borderColor"
          >
            {{ userInitials().replaceAll('.', '') }}
          </div>
        }
        @if (isB2B()) {
          <div
            class="h-11 w-11 rounded-full bg-white overflow-hidden mr-2.5 flex items-center justify-center border border-borderColor"
          >
            <sc-svg name="profile-avatar" size="w-11 h-11"></sc-svg>
          </div>
        }
        @if (user()) {
          <div class="flex flex-col justify-center">
            @if (userNameDetails() && !isB2B()) {
              <div
                class="text-base overflow-hidden whitespace-nowrap leading-none w-[245px] fade-effect"
              >
                {{ userNameDetails().firstName }} {{ userNameDetails().prefix }}
                {{ userNameDetails().lastName }}
              </div>
            }
            <div
              class="relative font-bold text-sm leading-none tablet:text-base cursor-pointer flex items-center"
              scClickToCopy="{{ user().email }}"
            >
              <div
                class="font-bold text-sm text-left w-[245px] overflow-hidden whitespace-nowrap fade-effect"
              >
                {{ user().email }}
              </div>
            </div>
          </div>
        }
      </div>
      <sc-button
        variant="icon"
        [padding]="false"
        class="px-0 w-5 h-5"
        (click)="close()"
        title="Close"
      >
        <sc-svg name="close" size="w-5 h-5"></sc-svg>
      </sc-button>
    </div>
  </div>

  <div class="flex items-center justify-between p-4 tablet:p-5">
    <p class="font-headline text-desktopH3">
      {{ productConfig().title | scTranslate | async }}
    </p>
    <sc-svg [name]="productConfig().headerIcon" class="h-10.5 w-10.5"></sc-svg>
  </div>

  <div class="relative px-4 tablet:px-5 pb-4 tablet:pb-5">
    <div #scrollContainer class="max-h-[180px] tablet:max-h-[204px] overflow-y-auto">
      <div class="!bg-[#F7F7F7]">
        <sc-msisdn-radio-button-list (msisdnSelected)="close()"></sc-msisdn-radio-button-list>
      </div>
    </div>

    <div class="pt-4 tablet:pt-5">
      <sc-button variant="alternate" [url]="mainUrl" class="h-10.5 flex items-center gap-x-1">
        <span class="text-sm tablet:text-base">
          {{ 'shared.addSim' | scTranslate | async }}
        </span>
        <sc-svg name="plus"></sc-svg>
      </sc-button>
    </div>
  </div>

  <div class="h-px w-full bg-borderColor"></div>

  @if (isProductSwitchAvailable()) {
    <div class="px-4 tablet:px-5 py-3">
      <sc-button
        variant="text"
        class="flex justify-between w-full"
        (click)="setActiveProduct(productConfig().switchProduct)"
      >
        <div class="flex justify-between items-center w-full">
          <div class="flex items-center gap-x-3">
            <sc-svg [name]="productConfig().switchIcon" class="h-[21px] w-[21px]"></sc-svg>

            <span>
              {{ productConfig().switchText | scTranslate | async }}
            </span>
          </div>

          <sc-svg name="arrow-right"></sc-svg>
        </div>
      </sc-button>
    </div>

    <div class="h-px w-full bg-borderColor"></div>
  }

  <div class="relative p-4 tablet:p-5" [formGroup]="form">
    <div class="absolute inset-x-0 bottom-0 h-px bg-borderColor"></div>
    <div>
      <div class="font-semibold text-sm tablet:text-base mb-1.5">
        {{ 'shared.language' | scTranslate | async }}
      </div>

      <div class="mb-1 tablet:mb-0">
        <sc-select
          formControlName="languageCode"
          [isDisabled]="true"
          (outSelectedOption)="outSelectedOption($event)"
          (click)="openList()"
        >
          @for (locale of localeList$ | async; track locale.code; let index = $index) {
            <sc-option
              [option]="{
                id: locale.code,
                label: locale.name | scRemoveTermShorthand,
              }"
            >
              {{ locale.name }}
            </sc-option>
          }
        </sc-select>
      </div>
    </div>
  </div>

  <div class="p-4 tablet:p-5 flex flex-col gap-3">
    <sc-button variant="primary" (click)="signout()" class="h-10.5">
      <span class="text-sm tablet:text-base">
        {{ 'shared.signOut' | scTranslate | async }}
      </span>
      <sc-svg name="door-out"></sc-svg>
    </sc-button>

    @if (!isLimited()) {
      <sc-button variant="icon" (click)="goToSettings()" class="h-10.5">
        <span class="text-sm tablet:text-base">
          {{ 'shared.goToSettings' | scTranslate | async }}
        </span>
        <sc-svg name="arrow-right"></sc-svg>
      </sc-button>
    }
  </div>
</div>
